/**
 * @generated SignedSource<<d92270dad2253b222d4edda68bdf994b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutTotals_item$data = {
  readonly canMultipleQuantityBePurchased: boolean | null;
  readonly isJewelry: boolean | null;
  readonly serviceId: string | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "CheckoutTotals_item";
};
export type CheckoutTotals_item$key = {
  readonly " $data"?: CheckoutTotals_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTotals_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTotals_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canMultipleQuantityBePurchased",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJewelry",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f533cd3fa20f6407756703df7961edfd";

export default node;
